export class NotImplementedException extends Error {
    constructor() {
        super("Not Implemented");
    }
}
